
import 'jquery-inview';
import 'masonry-layout';
import {colr} from "caniuse-lite/data/features";

( function($) {
  $('.js-inview').on('inview', function (event, isInView){
      if(isInView) {
        $(this).addClass('animate__fadeIn')
      } else {
      }
  });
  // frontpageのみ、headerの非表示
    $('#wrapper-hero').on('inview', function (event, isInView){
        const $target = $('.js-navbar-start');
        const class_name = 'is_active';
        if(!isInView) {
            $target.addClass(class_name);
        } else {
            $target.removeClass(class_name);
        }
    });
    const toc_replace = function(){
        const $window_width = $(window).width();
        if($window_width <= 768) {
            console.log($window_width);
            return false;

        }
        const $target = $('#toc_container');
        const $replace = $(".js-toc-widget");

        if ($target.length) {
            const $detached_all = $target.detach().find('.toc_list');
            const $toc_content = $detached_all.get(0).outerHTML;
            console.log($toc_content);
            $replace.html(`<div id="toc_container"><p>目次</p>${$toc_content}</div`);
            console.log($target)
            $('#toc_container').show();
        }
    }
    $(document).ready(function(){
        toc_replace();
        }
    );

})(jQuery);
